<div>
  <div class="add-title">
    <h2 class="primary" i18n="@@Add Umbrella">Add Umbrella</h2>
  </div>
  <div>
    <form [formGroup]="addForm" (change)="formChanged()">
      <mat-grid-list cols="1" [cols]="breakpoint" rowHeight="72px" (window:resize)="onResize($event)">
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field>
              <input matInput placeholder="Umbrella Name" i18n-placeholder="@@Umbrella Name" value={{name}} formControlName="name" required>
              <mat-error *ngIf="addForm.controls.name.hasError('required')" i18n="@@Please enter an umbrella name">Please enter an umbrella name</mat-error>
              <mat-error *ngIf="addForm.controls.name.hasError('pattern')" i18n="@@Please enter a valid umbrella name">Please enter a valid umbrella name</mat-error>
            </mat-form-field>
          </div>
        </mat-grid-tile>
        <mat-grid-tile>
          <div class="text-inside">
            <mat-form-field class="full-width">
              <mat-select  placeholder="Organization" i18n-placeholder="@@Organization" formControlName="organization" required>
                <ng-container *ngFor="let organization of organizations">
                  <mat-option *ngIf="!isOrganizationAlreadyAnUmbrella(organization.ID)" [value]="organization">{{organization.ID}} {{organization.name}}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        </mat-grid-tile>
      </mat-grid-list>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <button mat-raised-button type="submit" color="primary" class="Update-btn" mat-dialog-close="" [disabled]="addForm.invalid" (click)="onAdd()" i18n="@@Add Umbrella">Add Umbrella</button>
      </div>
    </form>
  </div>
</div>
